<script setup lang="ts">
import { computed } from 'vue';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/cn';

const badgeVariants = cva(
  ['inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-micro font-medium uppercase tracking-wide whitespace-nowrap'],
  {
    variants: {
      variant: {
        neutral: 'bg-bg text-text-muted border border-border',
        accent: 'bg-accent/10 text-accent',
        success: 'bg-success/10 text-success',
        warning: 'bg-warning/15 text-warning',
        danger: 'bg-danger/10 text-danger',
        outline: 'border border-border-strong text-text-muted',
      },
    },
    defaultVariants: { variant: 'neutral' },
  },
);

type BadgeVariants = VariantProps<typeof badgeVariants>;

const props = defineProps<{ variant?: BadgeVariants['variant']; class?: string }>();
const classes = computed(() => cn(badgeVariants({ variant: props.variant }), props.class));
</script>

<template>
  <span :class="classes">
    <slot />
  </span>
</template>
